import React from 'react';
import { CalendarDaysIcon, PhoneIcon } from 'lucide-react';
import { practice } from '../data/site';
export function MobileStickyBar() {
  return <div className="glass-dark fixed inset-x-0 bottom-0 z-[65] rounded-none border-x-0 border-b-0 lg:hidden" data-id="element-367" data-mp="3pd7y12v6wy1y">
      <div aria-hidden="true" className="mx-auto h-[2px] w-16 bg-accent" data-id="element-368" data-mp="73pdjzvzhg9q" />
      <div className="grid grid-cols-2 gap-3 px-4 py-3" data-id="element-369" data-mp="254bdux68min">
        <a href={practice.phoneHref} className="flex min-h-[48px] items-center justify-center gap-2 rounded-[10px] border border-white/25 text-[15px] font-medium text-white" data-id="element-370" data-mp="g5yj0bceajg9">
          <PhoneIcon aria-hidden="true" className="h-4 w-4" strokeWidth={1.75} data-id="element-371" data-mp="pwjg1ucf7fx2" />
          Call
        </a>
        <a href={practice.bookingUrl} target="_blank" rel="noreferrer" className="flex min-h-[48px] items-center justify-center gap-2 rounded-[10px] bg-white text-[15px] font-medium text-ink" data-id="element-372" data-mp="kwx5xtrw2fsh">
          <CalendarDaysIcon aria-hidden="true" className="h-4 w-4" strokeWidth={1.75} data-id="element-373" data-mp="ut9vqgkbc9hy" />
          Book appointment
        </a>
      </div>
    </div>;
}